import {
    ACTION_POST_CREATE_NOVELTIES,
    ACTION_PUT_UPDATE_NOVELTIES,
    ACTION_DELETE_NOVELTIES,
    ACTION_GET_NOVELTIES,
    SET_NOVELTIES
} from "@/views/novelties/store/types/types.js"

import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';
import { NoveltiesService } from "../../../services";
import i18n from '@/plugins/i18n';

const actions = {
    [ACTION_GET_NOVELTIES]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                NoveltiesService.getListNovelties(idGroup,idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload) {
                            const novelties = resp.data.payload;
                            commit(SET_NOVELTIES, novelties);
                            resolve(resp.data);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_NOVELTIES]: ({ state }, data) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");

        const formdata = new FormData();
        formdata.append("title", data.title);
        formdata.append("image", data.image);
        formdata.append("message", data.message);
        formdata.append("functionalityId", data.functionalityId);
        formdata.append("startDate", data.startDate);
        formdata.append("endDate", data.endDate);
        formdata.append("companyIds", data.companyIds);
        formdata.append("status", true);
        
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                NoveltiesService.postCreateNovelty(idGroup, idEmpresa, idUsuario, formdata)
                    .then(async (resp) => {
                        if (resp.data.payload.newsUpdateId) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('novelties.actionPostCreateNovelties.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                            EventBus.$emit('formNovelties-submitted-successfully');
                        } else {
                            await Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: resp.data.payload.body.payload.Error,
                            });
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_NOVELTIES]: async ({ state }, data) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");
        
        const formdata = new FormData();
        formdata.append("title", data.title);
        formdata.append("image", data.image);
        formdata.append("message", data.message);
        formdata.append("functionalityId", data.functionalityId);
        formdata.append("startDate", data.startDate);
        formdata.append("endDate", data.endDate);
        formdata.append("companyIds", data.companyIds);
        formdata.append("status", data.status);
        
        return await new Promise((resolve, reject) => {
            state.loading = true;
            NoveltiesService.postUpdateNovelty(idGroup, idEmpresa, idUsuario, formdata, data.newsUpdateId)    
                .then(async (resp) => {
                    if (resp.data.payload.newsUpdateId) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('novelties.actionPutUpdateNovelties.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                        EventBus.$emit('reload-update-novelties');
                    } else {
                        await Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: resp.data.payload.body.payload.Error,
                        });
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },

    [ACTION_DELETE_NOVELTIES]: async ({ state }, newsUpdateId) => {
        const idGroup = sessionStorage.getItem("idGroup");
        const idEmpresa = sessionStorage.getItem("idEmpresa");
        const idUsuario = sessionStorage.getItem("idUsuario");
        
        return await new Promise((resolve, reject) => {
            state.loading = true;
            NoveltiesService.getDeleteNovelty(idGroup, idEmpresa, idUsuario, newsUpdateId) 
                .then(async (resp) => {
                    if (resp) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('novelties.actionDeleteNovelties.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                        EventBus.$emit('reload-delete-novelties');
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
}

export default actions;